<template>
<v-app>
    <v-main app class="auth-pages">
        <fade-transition
            :duration="200"
            origin="center top"
            mode="out-in">
            <!-- your content here -->
            <v-container class="pt-6">
                <router-view></router-view>
                <!--content-footer auth v-if="!$route.meta.hideFooter"></content-footer-->
            </v-container>
        </fade-transition>
    </v-main>
</v-app>
</template>

<script>
import {
    FadeTransition
} from "vue2-transitions";
export default {
    name: "page-layout",
    components: {
        FadeTransition,
    },
    data() {
        return {
            paragraphs: "",
            tab: null,
            sheet: false,
            formValid: false,
            uid: "",
            password: "",
        };
    },
    methods: {
        headerTitle() {
            switch (this.$route.name) {
                case "SignUpBasic":
                    this.paragraphs =
                        "Use these awesome forms to login or create new account in your project for free.";
                    return "Welcome!";
                default:
                    break;
            }
        }
    },
};
</script>
